import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function AccordionItem({ alwaysShowButtonLabel, buttonLabel, children, expanded, icon, onClick, title }) {
  var content;
  buttonLabel = buttonLabel || title;
  if (expanded) {
    content = (
      <div className="accordion_body">
        {children}
      </div>
    );
  }
  return (
    <div className={classes({
      "accordion_item": true,
      "accordion_item--is-expanded": expanded
    })}>
      <button className="accordion_button btn btn--small" onClick={onClick} type="button">
        <i className={classes({
          [icon]: true,
          "dw--1-5x": true
        })} />

        <span className={classes({
          "accordion_button-label": true,
          "hidden--base": !alwaysShowButtonLabel
        })}>
          {buttonLabel}
        </span>
      </button>

      <div className="accordion_content">
        <div className="accordion_heading">
          {title}
        </div>

        <button className="accordion_close" onClick={onClick} type="button">
          <i className="dw-times" />
        </button>

        {content}
      </div>
    </div>
  );
});
